'use client';
import useSWR from 'swr';
import { API_URLS, SWR_REQUEST_DEFAULTS } from '@/lib/api/config';
import { TypePlayGeniusOrderResponse } from '@/lib/api/orderManager/types';

export default function useCustomerOrders(userUuid: string) {
  const uri = `${API_URLS.ORDER_MANAGER_PROXY}/users/${userUuid}/orders`;

  const {
    data: customerOrdersData,
    isLoading: customerOrdersLoading,
    error: customerOrdersError,
    mutate: mutateCustomerOrders,
  } = useSWR<TypePlayGeniusOrderResponse, Error>(uri, SWR_REQUEST_DEFAULTS);

  return {
    customerOrdersData,
    customerOrdersLoading,
    customerOrdersError,
    mutateCustomerOrders,
  };
}
